export class OpportuniteDetails {
  user_id;
  user_entreprise_id;
  commerciaux_id;
  commerciaux_nom;
  commerciaux_prenom;
  main_prospect_id;
  main_prospect_name;
  date_depot;
  etat;
  description;
  etat_rdv_id;
  campagne_id;
  last_update;
  type_opportunite;
  opportunite_parent;
  startRdv;
  endRdv;
  tags;
  allowed_to_update;
  etat_id;
  bien;
  person;
}
 export class GetOpportuniteDetails {
  opportunite_details: OpportuniteDetails = new OpportuniteDetails();
  id;
  real_id;
}

